import { cn } from './utils';
import { formatCurrency } from './utils';

// Re-export utilities
export { cn, formatCurrency };

// Container class for consistent layout
export const containerClass = "mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8";

